export default __webpack_public_path__ + "static/media/Platypus.cc03ba6d.png";